<template>
  <div class="pcenter" style="margin-top: 20px; flex-wrap: wrap;">
    <div style="width:100%; display: flex; align-items: center; justify-content: center;">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="购买月数:">
          <el-input-number v-model="num" @change="numchange"></el-input-number>
        </el-form-item>
        <el-form-item validate-event label="费用:">
          <span style="color: green">{{price}}</span>
        </el-form-item>
      </el-form>
    </div>
    <div :hidden="codeshow" style="display: flex; flex-flow: column; align-items: center; justify-content: center;">
      <div id="qrcode" ref="qrcode"></div>
      <div style="margin-top: 30px; margin-bottom: 30px; color: green">扫描上面二维码进行微信支付</div>
      <div style="margin-top: 30px; margin-bottom: 30px; color: green">{{paystate}}</div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Utils from '../../util/utils'
  import axios from 'axios'
  import QRCode from 'qrcodejs2'
  import { EventBus } from '../../util/event-bus.js'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'BuyModel',
    data () {
      return {
        num: 1,
        price: 0,
        subprice: 0,
        gid: 0,
        gidstr: '',
        codeshow: false,
        paystate: '请扫码支付',
        sytime: 60
      }
    },
    mounted () {
      that = this
    },
    methods:{
      buymodelbyid (gid) {
        that.gid = gid
        if (that.gid === 1) {
          var qstr = 'mgroupid = 1'
          that.$http({
            url: 'http://api.sqnetsoft.cn/permission/gmi',
            method: 'post',
            data: {
              whereinfo: {String: qstr, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                if (res.data.data !== '[]') {
                  var tmpdata = JSON.parse(res.data.data)
                  window.console.log(tmpdata)
                  var jcstr = {
                    Id: '1',
                    AppID: '100',
                    Name: '基础',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  var ywstr = {
                    Id: '2',
                    AppID: '100',
                    Name: '业务',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  for (var i=0; i<tmpdata.length; i++) {
                    if (tmpdata[i].type === 1) {
                      jcstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                    if (tmpdata[i].type === 2) {
                      ywstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                  }
                  var modeltmpdata = JSON.parse(localStorage.getItem('models'))
                  window.console.log(modeltmpdata)
                  modeltmpdata[0].Children.unshift(ywstr)
                  modeltmpdata[0].Children.unshift(jcstr)
                  if (localStorage.getItem('addmodels') === null) {
                    that.$options.methods.runbuycomm(modeltmpdata,"'1'")
                  } else {
                    var tmpmodels = localStorage.getItem('addmodels')
                    if (tmpmodels.indexOf('1') === -1) {
                      window.console.log('未购买')
                      tmpmodels = tmpmodels + ",'1'"
                      that.$options.methods.runbuycomm(modeltmpdata,tmpmodels)
                    } else {
                      window.console.log('已购买')
                    }
                  }
                }
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          var qstr1 = 'mgroupid = 1'
          that.$http({
            url: 'http://api.sqnetsoft.cn/permission/gmi',
            method: 'post',
            data: {
              whereinfo: {String: qstr1, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                if (res.data.data !== '[]') {
                  var tmpdata = JSON.parse(res.data.data)
                  window.console.log(tmpdata)
                  var jcstr = {
                    Id: '1',
                    AppID: '100',
                    Name: '基础',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  var ywstr = {
                    Id: '2',
                    AppID: '100',
                    Name: '业务',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  for (var i=0; i<tmpdata.length; i++) {
                    if (tmpdata[i].type === 1) {
                      jcstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                    if (tmpdata[i].type === 2) {
                      ywstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                  }
                  var modeltmpdata = JSON.parse(localStorage.getItem('models'))
                  window.console.log(modeltmpdata)
                  modeltmpdata[0].Children.unshift(ywstr)
                  modeltmpdata[0].Children.unshift(jcstr)
                  if (localStorage.getItem('addmodels') === null) {
                    that.$options.methods.runbuycomm(modeltmpdata,'1')
                  } else {
                    var tmpmodels = localStorage.getItem('addmodels')
                    if (tmpmodels.indexOf('1') === -1) {
                      window.console.log('未购买')
                      tmpmodels = tmpmodels + ",'1'"
                      that.$options.methods.runbuycomm(modeltmpdata,tmpmodels)
                    } else {
                      window.console.log('已购买')
                    }
                  }
                }
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      buymodel () {
        if (that.gid === 1) {
          var qstr = 'mgroupid = 1'
          that.$http({
            url: 'http://api.sqnetsoft.cn/permission/gmi',
            method: 'post',
            data: {
              whereinfo: {String: qstr, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                if (res.data.data !== '[]') {
                  var tmpdata = JSON.parse(res.data.data)
                  window.console.log(tmpdata)
                  var jcstr = {
                    Id: '1',
                    AppID: '100',
                    Name: '基础',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  var ywstr = {
                    Id: '2',
                    AppID: '100',
                    Name: '业务',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  for (var i=0; i<tmpdata.length; i++) {
                    if (tmpdata[i].type === 1) {
                      jcstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                    if (tmpdata[i].type === 2) {
                      ywstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                  }
                  var modeltmpdata = JSON.parse(localStorage.getItem('models'))
                  window.console.log(modeltmpdata)
                  modeltmpdata[0].Children.unshift(ywstr)
                  modeltmpdata[0].Children.unshift(jcstr)
                  if (localStorage.getItem('addmodels') === null) {
                    that.$options.methods.runbuycomm(modeltmpdata,'1')
                  } else {
                    var tmpmodels = localStorage.getItem('addmodels')
                    if (tmpmodels.indexOf('1') === -1) {
                      window.console.log('未购买')
                      tmpmodels = tmpmodels + ",'1'"
                      that.$options.methods.runbuycomm(modeltmpdata,tmpmodels)
                    } else {
                      window.console.log('已购买')
                    }
                  }
                }
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          var qstr1 = 'mgroupid = 1'
          that.$http({
            url: 'http://api.sqnetsoft.cn/permission/gmi',
            method: 'post',
            data: {
              whereinfo: {String: qstr1, Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                if (res.data.data !== '[]') {
                  var tmpdata = JSON.parse(res.data.data)
                  window.console.log(tmpdata)
                  var jcstr = {
                    Id: '1',
                    AppID: '100',
                    Name: '基础',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  var ywstr = {
                    Id: '2',
                    AppID: '100',
                    Name: '业务',
                    ParentID: '318',
                    Level: 1,
                    HasChild: 1,
                    Icon: {String: '', Valid: false},
                    ModelUrl: {String: '', Valid: false},
                    Leaf: 'false',
                    Children:[]
                  }
                  for (var i=0; i<tmpdata.length; i++) {
                    if (tmpdata[i].type === 1) {
                      jcstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                    if (tmpdata[i].type === 2) {
                      ywstr.Children.push(JSON.parse(tmpdata[i].modelstr.String))
                    }
                  }
                  var modeltmpdata = JSON.parse(localStorage.getItem('models'))
                  window.console.log(modeltmpdata)
                  modeltmpdata[0].Children.unshift(ywstr)
                  modeltmpdata[0].Children.unshift(jcstr)
                  if (localStorage.getItem('addmodels') === null) {
                    that.$options.methods.runbuycomm(modeltmpdata,'1')
                  } else {
                    var tmpmodels = localStorage.getItem('addmodels')
                    if (tmpmodels.indexOf('1') === -1) {
                      window.console.log('未购买')
                      tmpmodels = tmpmodels + ",'1'"
                      that.$options.methods.runbuycomm(modeltmpdata,tmpmodels)
                    } else {
                      window.console.log('已购买')
                    }
                  }
                }
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      changemenu (models) {
        var updatas = []
        var updata = {
          userid: parseInt(localStorage.getItem('accountid')),
          models: models.toString()
        }
        updatas.push(updata)
        that.$http({
          url: 'http://api.sqnetsoft.cn/permission/papu',
          method: 'post',
          data: updatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            if (res.data.success) {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      runbuycomm (modeltmpdata,tmpmodels) {
        let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
        var adata = {
          accountid: parseInt(localStorage.getItem('accountid')),
          buymodel: {String: that.gid.toString(), Valid: true},
          buymonth: parseInt(that.num),
          buytime: {String: addtime, Valid: true},
          state: parseInt(1)
        }
        that.$http({
          url: 'http://api.sqnetsoft.cn/permission/aaubmb',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            if (res.data.success) {
              localStorage.setItem('models',JSON.stringify(modeltmpdata))
              that.$options.methods.changemenu(JSON.stringify(modeltmpdata))
              EventBus.$emit('reloadmenu')
              that.$emit('closebuy')
              localStorage.setItem('addmodels',tmpmodels)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      checkorder () {
        that.$http({
          url: 'https://api.sqnetsoft.cn/wx/qorder',
          method: 'post',
          data: {
            appid: 'wxb6b6a21ef8474770',
            mchid: '1573495261',
            outtradeno: localStorage.getItem('buyorderno')
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res.data.data)
            if (getXmlNode(res.data.data).length > 0) {
              window.console.log(getXmlNode(res.data.data)[0].innerHTML)
              if (getXmlNode(res.data.data)[0].innerHTML === '<![CDATA[支付成功]]>') {
                localStorage.setItem('paystate',1)
              } else {
                localStorage.setItem('paystate',0)
              }
              /*
              if (getXmlNode(res.data.data)[0].innerHTML === '<![CDATA[支付成功]]>') {
                return true
              } else {
                return false
              }
               */
            } else {
              localStorage.setItem('paystate',0)
            }
          })
          .catch(function (error) {
            localStorage.setItem('paystate',0)
            window.console.log(error)
          })
      },
      startorder () {
        localStorage.setItem('paystate',0)
        that.sytime = 60
        that.paystate = '等待支付 ' + that.sytime
        let interval = window.setInterval(function() {
          that.paystate = '等待支付 ' + that.sytime
          --that.sytime;
          if (that.sytime % 5 === 0) {
            if (parseInt(localStorage.getItem('paystate')) === 1) {
              that.sytime = 60;
              that.paystate = '支付完毕'
              that.$options.methods.buymodel()
            } else {
              window.console.log('还未支付')
              that.$options.methods.checkorder()
            }
          }
          if (that.sytime < 0) {
            that.sytime = 60;
            window.clearInterval(interval);
          }
        }, 1000);
        localStorage.setItem('interval',interval)
      },
      makecode (tmpgid,price) {
        this.gid = tmpgid
        this.subprice = price
        this.price = parseInt(this.num) * parseInt(price)
        that.gidstr = localStorage.getItem('accountid') + ',' + that.gid + ',' + that.subprice + ',' + that.num + ',' + getRandom(2);
        document.getElementById('qrcode').innerHTML = ''
        that.$http({
          url: 'https://api.sqnetsoft.cn/wx/getspparams',
          method: 'post',
          data: {
            goodid: that.gidstr
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.status === 200) {
              var tmpdata = res.data
              window.console.log(tmpdata)
              var sha1sign = tmpdata.sh1signature
              var md5sign = tmpdata.md5signature.toLocaleUpperCase()
              // var timestamp = Date.parse(new Date()).toString()
              // timestamp = timestamp.substr(0,10)
              var noncestr1 = randomWord(false, 30).toLocaleUpperCase()
              window.console.log(sha1sign)
              window.console.log(md5sign)
              window.console.log(noncestr1)
              var timestamp = tmpdata.timestamp
              var noncestr = tmpdata.nonce
              window.console.log(noncestr)
              window.console.log(timestamp)
              localStorage.setItem('buyorderno',tmpdata.orderno)
              var tmpurl = 'weixin://wxpay/bizpayurl?appid=wxb6b6a21ef8474770&mch_id=1573495261&nonce_str=' + noncestr + '&product_id=' + that.gidstr + '&time_stamp=' + timestamp + '&sign=' + md5sign
              window.console.log(tmpurl)
              var qrcode = new QRCode('qrcode', {
                width: 128,
                height: 128,
                colorDark : '#000000',
                colorLight : '#ffffff',
                correctLevel : QRCode.CorrectLevel.H,
                text: tmpurl // 生成二维码的链接
              })
              window.console.log(qrcode)
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      },
      numchange (val) {
        window.console.log(val)
        this.num = val
        this.codeshow = false
        this.price = parseInt(val) * parseInt(that.subprice)
        that.gidstr = localStorage.getItem('accountid') + ',' + that.gid + ',' + that.subprice + ',' + that.num + ',' + getRandom(2);
        document.getElementById('qrcode').innerHTML = ''
        that.$http({
          url: 'https://api.sqnetsoft.cn/wx/getspparams',
          method: 'post',
          data: {
            goodid: that.gidstr
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.status === 200) {
              var tmpdata = res.data
              window.console.log(tmpdata)
              var sha1sign = tmpdata.sh1signature
              var md5sign = tmpdata.md5signature.toLocaleUpperCase()
              // var timestamp = Date.parse(new Date()).toString()
              // timestamp = timestamp.substr(0,10)
              var noncestr1 = randomWord(false, 30).toLocaleUpperCase()
              window.console.log(sha1sign)
              window.console.log(md5sign)
              window.console.log(noncestr1)
              var timestamp = tmpdata.timestamp
              var noncestr = tmpdata.nonce
              window.console.log(noncestr)
              window.console.log(timestamp)
              var tmpurl = 'weixin://wxpay/bizpayurl?appid=wxb6b6a21ef8474770&mch_id=1573495261&nonce_str=' + noncestr + '&product_id=' + that.gidstr + '&time_stamp=' + timestamp + '&sign=' + md5sign
              window.console.log(tmpurl)
              var qrcode = new QRCode('qrcode', {
                width: 128,
                height: 128,
                colorDark : '#000000',
                colorLight : '#ffffff',
                correctLevel : QRCode.CorrectLevel.H,
                text: tmpurl // 生成二维码的链接
              })
              window.console.log(qrcode)
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      }
    }
  }
  function getXmlNode(str) {
    var parser=new DOMParser()
    var xmlDoc=parser.parseFromString(str,'text/xml')
    var countrys = xmlDoc.getElementsByTagName('trade_state_desc')
    return countrys;
  }
  function getRandom(num){
    var random = Math.floor((Math.random()+Math.floor(Math.random()*9+1))*Math.pow(10,num-1))
    return random
  }
  function randomWord (randomFlag, min, max) {
    var str = ''
    var range = min
    var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min
    }
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length - 1))
      str += arr[pos]
    }
    return str
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/model/BuyModel.vue